module.exports = __webpack_public_path__ + "img/3dh.bb638da6.png";